import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import * as S from '../styled/InfoLabel.styled';

/**
 * @author Burak Ak
 */

const InfoLabel = ({
	label,
	value,
	anchor,
	icon,
	iconSize = 'medium',
	anchorLink,
	rowMode,
	labelColor,
	valueColor,
	iconColor,
	labelFontWeight,
	valueFontWeight,
	labelVariant,
	valueVariant,
	className
}) => (
	<div className={className}>
		{rowMode ? (
			<S.InfoRowFlex>
				{icon && <Icon size={iconSize} className="addressIcon mx-2" color={iconColor} icon={icon} />}

				{label && (
					<Typography variant={labelVariant} noWrap fontWeight={labelFontWeight} color={labelColor}>
						{label}
					</Typography>
				)}

				{value && (
					<Typography
						variant={valueVariant}
						noWrap
						fontWeight={valueFontWeight}
						color={valueColor}
						className="mx-2">
						{value}
					</Typography>
				)}
				{anchor && (
					<a href={anchorLink} style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
						<Typography variant={valueVariant} noWrap fontWeight={valueFontWeight} css={S.Anchor}>
							{anchor}
						</Typography>
					</a>
				)}
			</S.InfoRowFlex>
		) : (
			<S.InfoRow>
				{icon && <Icon size={iconSize} className="addressIcon mx-3" color={iconColor} icon={icon} />}
				<span>
					{label && (
						<Typography variant={labelVariant} noWrap fontWeight={labelFontWeight} color={labelColor}>
							{label}
						</Typography>
					)}
					{value && (
						<Typography variant={valueVariant} noWrap fontWeight={valueFontWeight} color={valueColor}>
							{value}
						</Typography>
					)}
					{anchor && (
						<a href={anchorLink} style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
							<Typography variant={valueVariant} noWrap fontWeight={valueFontWeight} css={S.Anchor}>
								{anchor}
							</Typography>
						</a>
					)}
				</span>
			</S.InfoRow>
		)}
	</div>
);
export default InfoLabel;
